/**
 * Metzger Toast - Countdown Timer
 * Zeigt einen Floating Toast mit Countdown nach E-Mail Signup
 */
(function () {
  'use strict';

  const startTime = sessionStorage.getItem('metzger_countdown_start');
  if (!startTime) return;

  const duration = parseInt(sessionStorage.getItem('metzger_countdown_duration') || 60000);
  const elapsed = Date.now() - parseInt(startTime);
  let remaining = Math.max(0, duration - elapsed);

  // Zeit schon abgelaufen? Zeige Success und räum auf
  if (remaining <= 0) {
    showSuccessToast();
    cleanup();
    return;
  }

  // Toast Element erstellen
  const toast = document.createElement('div');
  toast.className = 'metzger-toast';
  toast.id = 'metzger-toast';
  toast.innerHTML = `
    <div class="metzger-toast-icon">🔪</div>
    <div class="metzger-toast-content">
      <div class="metzger-toast-title">Der Metzger füllt deinen Gutschein aus...</div>
      <div class="metzger-toast-hint">Stöber schon mal durch unsere Premium-Cuts! 🥩</div>
      <div class="metzger-toast-timer" id="metzger-timer">0:00</div>
      <div class="metzger-toast-progress">
        <div class="metzger-toast-progress-bar" id="metzger-progress"></div>
      </div>
    </div>
  `;
  document.body.appendChild(toast);

  const timerEl = document.getElementById('metzger-timer');
  const progressEl = document.getElementById('metzger-progress');

  function updateTimer() {
    remaining = Math.max(0, duration - (Date.now() - parseInt(startTime)));
    const secs = Math.ceil(remaining / 1000);
    const mins = Math.floor(secs / 60);
    const s = secs % 60;

    timerEl.textContent = mins + ':' + s.toString().padStart(2, '0');
    progressEl.style.width = ((remaining / duration) * 100) + '%';

    if (remaining <= 0) {
      clearInterval(interval);
      showSuccessToast();
      cleanup();
    }
  }

  // Initial update + interval
  updateTimer();
  const interval = setInterval(updateTimer, 1000);

  function showSuccessToast() {
    let toastEl = document.getElementById('metzger-toast');

    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'metzger-toast';
      toastEl.id = 'metzger-toast';
      document.body.appendChild(toastEl);
    }

    toastEl.classList.add('success');
    toastEl.innerHTML = `
      <div class="metzger-toast-icon">🎉</div>
      <div class="metzger-toast-content">
        <div class="metzger-toast-title">Dein Gutscheincode ist da!</div>
        <div class="metzger-toast-subtitle">Check deine Inbox 📬</div>
      </div>
    `;

    // Nach 4 Sekunden ausblenden (schneller, um Buttons nicht zu blockieren)
    setTimeout(function () {
      toastEl.classList.add('fade-out');
      setTimeout(function () {
        toastEl.remove();
      }, 400);
    }, 4000);
  }

  function cleanup() {
    sessionStorage.removeItem('metzger_countdown_start');
    sessionStorage.removeItem('metzger_countdown_duration');
  }
})();
